import { render, staticRenderFns } from "./ReactivateSubscription.vue?vue&type=template&id=2523708a&"
import script from "./ReactivateSubscription.vue?vue&type=script&lang=js&"
export * from "./ReactivateSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports